import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class MdaProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(public http: HttpClient) {}

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + '/mda/tipo-ocorrencia').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getMda() {
    return this.http.get<any>(this.baseUrl + '/mda').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getPessoaMdaById(idPessoa) {
    return this.http.get<any>(this.baseUrl + '/mda/get-by-id-pessoa/' + idPessoa).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  removerVinculo(id, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/mda/excluir-vinculo', {
        id: id,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getByMda(id) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  desmarcar(idEncontro, idMda, motivo, desmarcadoPor) {
    return this.http
      .post<any>(this.baseUrl + '/mda/desmarcar-encontro', {
        idEncontro: idEncontro,
        idMda: idMda,
        motivo: motivo,
        desmarcadoPor: desmarcadoPor,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  remarcar(idEncontro, data, hora) {
    return this.http
      .post<any>(this.baseUrl + '/mda/remarcar-encontro', {
        idEncontro: idEncontro,
        data: data,
        hora,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarMda(encontro) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-encontro', encontro).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarHistorico(historico) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-historico', historico).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  ultimosEncontros(id) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id + '/encontros').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getHistoricos(id) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id + '/historico').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getEncontroTipo() {
    return this.http.get<any>(this.baseUrl + '/mda/get-encontro-tipo').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarVinculo(mda) {
    mda.horarioInicio = mda.horarioInicio ? mda.horarioInicio.replace(':', '') : '';
    return this.http.post<any>(this.baseUrl + '/mda/salvar-vinculo', mda).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarQualidadeDiscipulado(qualidade) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-avaliacao-discipulo', qualidade).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  salvarReporte(reporte) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-reporte-discipulo', reporte).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  solicitacao() {
    return this.http.post<any>(this.baseUrl + '/mda/solicitacao', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  confirmarEncontro(idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/mda/confirmar-encontro', {
        idEncontro: idEncontro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/mda/mda.ts